import logoSvg from "../../assets/fableous_logo.svg";
import ResponsiveImage from "../layout/ResponsiveImage";

export default function FableousLogo({maxHeight} : {maxHeight? : number}){
    return(
        <ResponsiveImage 
            alt="Logo for Fableous"
            originalHeight={510} 
            originalWidth={560} url={logoSvg} maxHeight={maxHeight} />
    )
}